import Gregorian_Date from "./Gregorian_Date";
import Hour_Time from "./Hour_Time";

export default class Gregorian_Datetime {
	date: Gregorian_Date;
	time: Hour_Time;

	constructor(date: Gregorian_Date, time: Hour_Time) {
		this.date = date;
		this.time = time;
	}

	getDate(): Gregorian_Date {
		return this.date;
	}

	getTime(): Hour_Time {
		return this.time;
	}

	// don't add any other formatting here, it's not up this library to provide that.

	canonicalformat(): string {
		return this.date.canonicalformat() + " " + this.time.canonicalformat();
	}

	htmlformat(): string {
		return this.date.canonicalformat() + "T" + this.time.canonicalformat();
	}
}
